import { render, staticRenderFns } from "./University.vue?vue&type=template&id=32864122&scoped=true&"
import script from "./University.vue?vue&type=script&lang=js&"
export * from "./University.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32864122",
  null
  
)

export default component.exports